<mat-card appearance="outlined" style="overflow: auto;">
	<app-vinavon-button>
		<button (click)="startSync()" mat-raised-button>
			<mat-icon>sync</mat-icon>
			{{ "Synchronisation starten" }}
		</button>
	</app-vinavon-button>
	
	<div class="contentContainer">
		<ejs-grid #gridAuftraege (dataBound)='dataBound()' (rowDeselected)='rowDeselected()' (rowSelected)='rowSelected()' [allowSorting]='true' [dataSource]='auftragZeilen'
		          [sortSettings]='sortOptions' [style.overflow]="'auto'" height='400px'>
			<e-columns>
				<e-column [visible]='false' field='serviceID' headerText='ID' width='0'></e-column>
				<e-column [format]='swissDatumFormat' field='datum' headerText='Datum' textAlign='Right' type='date' width=110></e-column>
				<e-column field='auftrag' headerText='Auftrag' textAlign='Left' width=130></e-column>
				<e-column field='bezeichnung' headerText='Bezeichnung' textAlign='Left'></e-column>
				<e-column field='kunde' headerText='Kunde' textAlign='Left'></e-column>
				<e-column field='anzDokumente' headerText='Anzahl Dokumente' textAlign='Left' width=160></e-column>
				<e-column editType="booleanedit" field='abgeschlossen' headerText='Abgeschlossen' textAlign='Center' type="boolean" width=150>
					<ng-template #template let-data>
						<div>
							<ejs-checkbox (change)='checkboxChange($event)' [checked]='data.abgeschlossen' [disabled]='data.uebermittelt'></ejs-checkbox>
						</div>
					</ng-template>
				</e-column>
				<e-column field='uploadNoetig' headerText='Upload' textAlign='Center' width=40>
					<ng-template #template let-column>
						<ng-container *ngIf="column.uploadNoetig">
							<img alt="ok" height="16" ngSrc="/assets/images/ok.png" style='width: 16px; height: 16px' width="16"/>
						</ng-container>
					</ng-template>
					<ng-template #headerTemplate let-data>
						<img alt="upload" height="16" ngSrc="/assets/images/upload.png" style='width: 16px; height: 16px' width="16"/>
					</ng-template>
				</e-column>
			</e-columns>
		</ejs-grid>
	</div>
</mat-card>